<template>
  <div
    class="box-border h-320 w-full bg-[#FFFBF7] pb-20 pt-30 text-sm text-black-3"
  >
    <div class="mx-auto flex w-wrap justify-between">
      <div class="flex">
        <div class="w-220">
          <div class="flex items-center space-x-10 text-xl">
            <div class="h-18 w-3 rounded-full bg-primary"></div>
            <span class="font-bold">我们足迹踏过的地区</span>
          </div>
          <div class="mt-20 flex flex-col space-y-15">
            <div class="flex flex-wrap gap-x-20 gap-y-8 text-black-6">
              <NuxtLink
                :to="`/travel-projects?area=${item.parentId}&country=${item.id}`"
                v-for="item in hotCountryData"
                >{{ item.menuName }}</NuxtLink
              >
            </div>
          </div>
        </div>
        <div class="ml-50">
          <div class="flex items-center space-x-10 text-xl">
            <div class="h-18 w-3 rounded-full bg-primary"></div>
            <span class="font-bold">逍遥游旅游网</span>
          </div>
          <div class="flex flex-col space-y-8 text-black-6">
            <div class="mt-20">因为年轻，所以旅行。</div>
            <div>一个与您共同成长的旅行日记网站。</div>
          </div>
        </div>
        <!-- <div class="ml-40 mt-50 h-80 w-1 bg-[#E0E8F6]"></div> -->
        <div class="ml-50">
          <div class="flex items-center space-x-10 text-xl">
            <div class="h-18 w-3 rounded-full bg-primary"></div>
            <span class="font-bold">关于我们</span>
          </div>
          <div class="flex flex-col space-y-8 text-black-6">
            <NuxtLink to="" class="mt-20 cursor-pointer">隐私政策</NuxtLink>
            <NuxtLink to="" class="cursor-pointer">用户协议</NuxtLink>
          </div>
        </div>
        <!-- <div class="ml-40 mt-50 h-80 w-1 bg-[#E0E8F6]"></div> -->
      </div>
      <div class="ml-40 flex items-center space-x-20">
        <div class="flex flex-col items-center">
          <img
            src="~/assets/img/contract_travel_qrcode.png"
            class="h-90 w-90 object-contain"
            alt=""
          />
          <span class="mt-5">旅游顾问</span>
          <span>(扫码添加)</span>
        </div>
        <!-- <div class="flex flex-col items-center">
          <img
            src="~/assets/img/contract_laowu_qrcode.png"
            class="h-90 w-90 object-contain"
            alt=""
          />
          <span class="mt-5">劳务顾问</span>
          <span>(扫码添加)</span>
        </div> -->
      </div>
    </div>
    <div class="mt-30 h-1 w-full bg-[#E0E8F6]"></div>
  </div>
</template>

<script setup>
const { data } = await useMyFetch(`website/basic/directoryList?isHotspot=1`)
const hotCountryData = computed(() => data.value?.dataList ?? [])
</script>

<style lang="scss" scoped></style>
